import React from 'react';
import { useMessage } from '../../contexts/MessageContext';
import AnimatedMessageList from './AnimatedMessageList';

const MessageContainer = () => {
  const { messages, hideMessage } = useMessage();

  if (messages.length === 0) {
    return null;
  }

  return (
    <div className="fixed top-4 left-1/2 transform -translate-x-1/2 z-50 pointer-events-none">
      <AnimatedMessageList 
        messages={messages} 
        onClose={hideMessage} 
      />
    </div>
  );
};

export default MessageContainer;
